import {
  isCustomPropertiesMutationAllowed,
  useConnectProject,
} from '@trimble/connect-project-providers';
import { createMemo, type Accessor } from 'solid-js';
import { useApiServices } from './ApiServiceProvider';

export function useCustomPropertiesMutationAllowed(): Accessor<
  boolean | undefined
> {
  const { selectedProjectId } = useConnectProject();
  const { ecomApi } = useApiServices();

  const accessPolicyQuery = ecomApi.getAccessPolicyQuery(selectedProjectId);

  const mutationAllowed = createMemo(() => {
    const projectId = selectedProjectId();

    if (projectId === undefined) {
      return false;
    }

    if (accessPolicyQuery.isPending) {
      return undefined;
    }

    if (accessPolicyQuery.isError || accessPolicyQuery.data === undefined) {
      return false;
    }

    return isCustomPropertiesMutationAllowed(accessPolicyQuery.data);
  });

  return mutationAllowed;
}
